// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tags[data-v-487c55e2]{display:flex;grid-gap:8px;gap:8px;flex-direction:column}@media (min-width:768px){.tags[data-v-487c55e2]{grid-gap:12px;gap:12px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
